import { z } from 'zod';

export const userSchema = z.object({
  id: z.number(),
  email: z.string(),
  name: z.string(),
  householdId: z.number(),
  language: z.string(),
  isManager: z.boolean(),
});
export type User = z.infer<typeof userSchema>;

/** Response shape for /auth/login, /auth/refresh, /auth/verify-email, and
 * /auth/signup/invite: the refresh token lives in an httpOnly cookie and is
 * never present in JSON. */
export const sessionResponseSchema = z.object({
  accessToken: z.string(),
  user: userSchema,
});
export type SessionResponse = z.infer<typeof sessionResponseSchema>;

export const signupResponseSchema = z.object({
  message: z.string(),
  email: z.string(),
});
export type SignupResponse = z.infer<typeof signupResponseSchema>;

export const inviteInfoSchema = z.object({
  householdName: z.string(),
  invitedBy: z.string(),
  email: z.string().optional(),
});
export type InviteInfo = z.infer<typeof inviteInfoSchema>;
